/**
 * Skeleton placeholder for the table list while it's being fetched. Fills
 * the available scroll area with a believable rhythm of "section header"
 * and "table item" bars.
 */
import { Skeleton } from "@mantine/core";

const SECTIONS: { headerWidth: string; items: string[] }[] = [
  { headerWidth: "55%", items: ["80%", "65%", "75%"] },
  { headerWidth: "45%", items: ["70%", "85%", "60%", "78%", "55%"] },
  { headerWidth: "60%", items: ["68%", "82%", "58%", "72%"] },
  { headerWidth: "50%", items: ["64%", "78%", "55%"] },
];

export function SidebarSkeleton() {
  return (
    <div
      style={{
        flex: 1,
        overflow: "hidden",
        padding: "8px 12px 16px",
        display: "flex",
        flexDirection: "column",
        gap: 12,
      }}
    >
      {/* Top "Favourites" / "All Tables" group header */}
      <Skeleton height={16} width="50%" radius="sm" />

      {SECTIONS.map((section, i) => (
        <div
          key={i}
          style={{ display: "flex", flexDirection: "column", gap: 8 }}
        >
          <Skeleton
            height={12}
            width={section.headerWidth}
            radius="sm"
            ml={12}
          />
          {section.items.map((w, j) => (
            <Skeleton
              key={j}
              height={10}
              width={w}
              radius="sm"
              ml={28}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
